var React = require('react');

function ButtonCircle (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#fff","strokeWidth":"1","fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"className":"bottom","opacity":"0.1","cx":"25","cy":"25","r":"24","key":0}),React.createElement("circle",{"className":"top","cx":"25","cy":"25","r":"24","key":1})]));
}

ButtonCircle.defaultProps = {"width":"50px","height":"50px","viewBox":"0 0 50 50","version":"1.1"};

module.exports = ButtonCircle;

ButtonCircle.default = ButtonCircle;
